import type { FeaturesContent } from "../types";

export const features: FeaturesContent = {
  title: "Samme workspace, modeller inkluderet.",
  lead:
    "Det samme UCloud-projekt rummer nu dine data, dine beregninger og de " +
    "modeller, du kører mod dem, chat eller API, fra første eksperiment til " +
    "produktionskørsel.",
  screenshots: [
    {
      title: "Inferens-playground",
      description:
        "En enkel chatgrænseflade med øjeblikkelig adgang til alle modeller i kataloget. Afprøv prompts, sammenlign svar og stream resultater, og tag derefter de samme modeller i produktion gennem det OpenAI-kompatible API.",
      frameAriaLabel: "Inferens-playground screenshot",
      mockupAriaLabel: "Inferens-playground mockup",
    },
    {
      title: "Beregnings-workspace",
      description:
        "Gå fra en interaktiv session til planlagte jobs på delt GPU-kapacitet. Modeller, data, lagring og applikationer forbliver samlet i ét UCloud-projekt.",
      frameAriaLabel: "Beregnings-workspace screenshot",
      mockupAriaLabel: "Beregnings-workspace mockup",
    },
    {
      title: "Ingen tilmelding. Bare log ind.",
      description:
        "Dit universitetslogin er den eneste adgangskode, den samme som du allerede bruger til alt andet. Ingen brugeroprettelse, ingen API-nøgler, ingen indkøbsproces. Modellerne er allerede en del af dit workspace.",
      frameAriaLabel: "Ingen tilmelding. Bare log ind. screenshot",
      mockupAriaLabel: "Universitetslogin-mockup",
    },
  ],
};
